// removed by extract-text-webpack-plugin
module.exports = {"container":"_287Xr1i","menuItem":"_1Lr9s52","label":"_2UoQGIz","label__light":"_9unZirh","label__sale":"_3xmb2OY","subtitle":"_1cky1mG"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/MenuItem/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/MenuItem/index.css
// module chunks = client.sitechrome